import { render, staticRenderFns } from "./addMultipleCodes.vue?vue&type=template&id=ba94d87c&scoped=true&"
import script from "./addMultipleCodes.vue?vue&type=script&lang=js&"
export * from "./addMultipleCodes.vue?vue&type=script&lang=js&"
import style0 from "./addMultipleCodes.vue?vue&type=style&index=0&id=ba94d87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba94d87c",
  null
  
)

export default component.exports